<div class="info-form align-left">
  <h3><b>AJOUTER UN PARTICIPANT</b></h3>
  <!-- combo avec saisie > options d'ajout de participant -->
  <div class="appr-option-selector">
    <kendo-combobox [data]="listOptionsAppr" [placeholder]="'Nouveau participant'" [(ngModel)]="optionAppr"
      [textField]="'fullName'" [valueField]="'id'" class="small-r-margin full-size">
    </kendo-combobox>
  </div>

  <!-- Formulaire nouveau participant -->
  <form [formGroup]="formParticipant" *ngIf="optionAppr.id === -1">
    <!-- *ngIf="option d'ajout de participant sélectionnée dans la combo" -->

    <div class="full-size">
      <div class="three-block small-field">
        <kendo-combobox [data]="listCiv" [placeholder]="'Civ.'" formControlName="civ" class="small-r-margin full-size">
        </kendo-combobox>
      </div>
      <div class="three-block">
        <input kendoTextBox [placeholder]="'Nom*'" formControlName="nom"
          class="small-r-margin small-l-margin full-size" />
      </div>
      <div class="three-block">
        <input kendoTextBox [placeholder]="'Prénom*'" formControlName="prenom" class="small-l-margin full-size" />
      </div>
      <div class="full-size alert-color"
        *ngIf="formParticipant.get('nom').hasError('required') && formParticipant.get('nom').touched">
        Veuillez renseigner un nom
      </div>
      <div class="full-size alert-color"
        *ngIf="formParticipant.get('prenom').hasError('required') && formParticipant.get('prenom').touched">
        Veuillez renseigner un prénom
      </div>
    </div>

    <div class="full-size">
      <div class="two-block">
        <input kendoTextBox [placeholder]="'Fonction'" formControlName="role" class="small-r-margin full-size" />
      </div>
      <div class="two-block">
        <input kendoTextBox [placeholder]="'Date de naissance*'" formControlName="birthdate"
          class="small-r-margin full-size" />
      </div>
    </div>

    <div class="full-size">
      <div class="two-block">
        <input kendoTextBox [placeholder]="'Téléphone'" formControlName="phone"
          class="small-r-margin small-l-margin full-size" />
      </div>
      <div class="two-block">
        <input kendoTextBox [placeholder]="'Mobile'" formControlName="mobile" class="small-l-margin full-size" />
      </div>
    </div>

    <div class="full-size">
      <div class="one-block">
        <input kendoTextBox [placeholder]="'Email*'" formControlName="mail" class="full-size" />
      </div>
      <div class="full-size alert-color"
        *ngIf="formParticipant.get('mail').hasError('required') && formParticipant.get('mail').touched">
        Veuillez renseigner une adresse mail
      </div>
    </div>

    <div class="full-size">
      <div class="one-block">
        <input kendoTextBox [placeholder]="'Confirmation Email*'" formControlName="confirmmail" class="full-size" />
      </div>
      <div class="full-size alert-color" *ngIf="
          (formParticipant.get('confirmmail').hasError('required') ||
            formParticipant.get('confirmmail').hasError('notMatch')) &&
          formParticipant.get('confirmmail').touched
        ">
        Les deux adresses saisies doivent être identiques
      </div>
    </div>

    <div class="full-size small-margin">
      <div class="one-block">
        <p class="full-size small-margin">RGPD Disclaimer: ----------------------------------------------</p>
      </div>
    </div>

    <div class="full-size align-right">
      <button kendoButton type="button" [primary]="true" class="colored-text small-margin align-left"
        style="font-size: .9em" (click)="addApprenant(false)" [disabled]="formParticipant.invalid">
        ENREGISTRER<br />Et ajouter un autre participant
      </button>
      <button kendoButton type="button" class="colored-text small-margin align-left" style="font-size: .9em"
        (click)="addApprenant(true)" [disabled]="formParticipant.invalid">
        ENREGISTRER<br />Et confirmer la commande
      </button>
    </div>
  </form>
  <div *ngIf="optionAppr.id !== -1">
    <div class="full-size align-right">
      <button kendoButton type="button" [primary]="true" class="colored-text small-margin align-left"
        style="font-size: .9em" (click)="addApprenant(false)">
        ENREGISTRER<br />Et ajouter un autre participant
      </button>
      <button kendoButton type="button" class="colored-text small-margin align-left" style="font-size: .9em"
        (click)="addApprenant(true)">
        ENREGISTRER<br />Et confirmer la commande
      </button>
    </div>
  </div>
</div>
<div class="list-section">
  <h3><b>LISTE DES PARTICIPANTS</b></h3>

  <kendo-grid [data]="currentResa ? currentResa.participants : []" class="no-border">
    <kendo-grid-column field="id" title="ID" [width]="10" [headerClass]="'no-border'" [class]="'no-border'">
    </kendo-grid-column>
    <kendo-grid-column field="name" title="Nom" [width]="200" [headerClass]="'no-border'" [class]="'no-border'">
    </kendo-grid-column>
    <kendo-grid-column field="firstName" title="Prénom" [headerClass]="'no-border'" [class]="'no-border'">
    </kendo-grid-column>
    <kendo-grid-column field="mail" title="Email" [width]="150" [headerClass]="'no-border'" [class]="'no-border'">
    </kendo-grid-column>
    <kendo-grid-column [width]="80" [headerClass]="'no-border'" [class]="'no-border'">
      <ng-template kendoGridCellTemplate let-rowIndex="rowIndex">
        <button kendoButton [look]="'flat'" [icon]="'close'" class="full-size alert-color"
          (click)="remove(rowIndex)"></button>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
